module.exports = __webpack_public_path__ + "static/media/BudgetSmartLogo.32f32034.svg";